// src/AudioSpectrum/effects/mirrorBars.js
import { getColor } from '../colorUtils.js';

export const drawMirrorBars = (ctx, frequencyData, width, height) => {
  const barCount = Math.min(frequencyData.length / 2, 128);
  const barWidth = width / barCount;
  const centerY = height / 2;
  
  ctx.clearRect(0, 0, width, height);
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const barHeight = (value / 255) * centerY;
    
    ctx.fillStyle = getColor(value);
    // 위쪽 바
    ctx.fillRect(i * barWidth, centerY - barHeight, barWidth - 2, barHeight);
    // 아래쪽 바 (미러)
    ctx.fillRect(i * barWidth, centerY, barWidth - 2, barHeight);
  }
  
  // 중앙선
  ctx.strokeStyle = '#4CAF50';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(0, centerY);
  ctx.lineTo(width, centerY);
  ctx.stroke();
};